import React from "react";
import VideoComponent from "../util/VideoComponent";

const VideosComponent = (props) => {
    return (
        <div>
            <VideoComponent id="AkV01" src={process.env.PUBLIC_URL + `/videos/AkV01.mp4`}/>
            <VideoComponent id="AlV01" src={process.env.PUBLIC_URL + `/videos/AlV01.mp4`}/>
            <VideoComponent id="AMV01" src={process.env.PUBLIC_URL + `/videos/AMV01.mp4`}/>
            <VideoComponent id="AZV01" src={process.env.PUBLIC_URL + `/videos/AZV01.mp4`}/>
            <VideoComponent id="PfV01" src={process.env.PUBLIC_URL + `/videos/PfV01.mp4`}/>
            <VideoComponent id="VPV01" src={process.env.PUBLIC_URL + `/videos/VPV01.mp4`}/>
            <VideoComponent id="RCV01" src={process.env.PUBLIC_URL + `/videos/RCV01.mp4`}/>
            <VideoComponent id="PMV01" src={process.env.PUBLIC_URL + `/videos/PMV01.mp4`}/>
            <VideoComponent id="PMV02" src={process.env.PUBLIC_URL + `/videos/PMV02.mp4`}/>
            <VideoComponent id="NV01" src={process.env.PUBLIC_URL + `/videos/NV01.mp4`}/>
            <VideoComponent id="MTV01" src={process.env.PUBLIC_URL + `/videos/MTV01.mp4`}/>
            <VideoComponent id="SV01" src={process.env.PUBLIC_URL + `/videos/SV01.mp4`}/>


            <VideoComponent id="DRAVS" src={process.env.PUBLIC_URL + `/videos/RCV01.mp4`}/>
            <VideoComponent id="DRBVS" src={process.env.PUBLIC_URL + `/videos/RCV01.mp4`}/>
            <VideoComponent id="ARAVS" src={process.env.PUBLIC_URL + `/videos/RCV01.mp4`}/>
            <VideoComponent id="ARBVS" src={process.env.PUBLIC_URL + `/videos/RCV01.mp4`}/>

            <VideoComponent id="RECEPGIFVIDEO" src={process.env.PUBLIC_URL + `/videos/RECEPGIFVIDEO.mp4`}/>
            <VideoComponent id="WELCOMEVIDEO" src={process.env.PUBLIC_URL + `/videos/WELCOMEVIDEO.mp4`}/>
            {/*<VideoComponent id="W19V340" src={process.env.PUBLIC_URL + `/videos/W19V340.mp4`}/>*/}
            {/*<VideoComponent id="W24V441" src={process.env.PUBLIC_URL + `/videos/W24V441a.mp4`}/>*/}

            {/*Audio*/}
            <VideoComponent id="MTA01" src={process.env.PUBLIC_URL + `/audio/MTA01.mp3`} audio="Y"/>
            <VideoComponent id="AIA01" src={process.env.PUBLIC_URL + `/audio/AlA01.mp3`} audio="Y"/>
            <VideoComponent id="AZA01" src={process.env.PUBLIC_URL + `/audio/AZA01.mp3`} audio="Y"/>
            <VideoComponent id="NA01" src={process.env.PUBLIC_URL + `/audio/NA01.mp3`} audio="Y"/>
            {/*<VideoComponent id="W23A01" src={process.env.PUBLIC_URL + `/audio/W23A01.mp3`} audio="Y"/>*/}

        </div>
    )
}

export default VideosComponent;
